export default [
  {
    id: "free",
    name: "Free",
    price: "Free",
    info: ["1 Fridge", "3 Content Types", "30-day trial"],
  },
  {
    id: "micro",
    annualId: "micro-annual",
    annualPrice: 7,
    name: "Micro",
    price: 9,
    info: ["1 Fridge", "10 Content Types", "2 User Roles"],
  },
  {
    id: "basic",
    annualId: "basic-annual",
    annualPrice: 22,
    name: "Basic",
    price: 29,
    info: ["3 Fridges", "25 Content Types", "10 User Roles"],
  },
  {
    id: "standard",
    annualId: "standard-annual",
    annualPrice: 37,
    name: "Standard",
    price: 49,
    info: ["5 Fridges", "Unlimited Content Types", "Unlimited User Roles"],
  },
];



// WEBPACK FOOTER //
// ./app/lib/plans.js